export enum StatusFormModuleData {

  Bozza = 1,
  DaValidare = 2,
  Validato = 3,
  Cancelled = 4

}
